// Shared by both forks; the old one restyles it with `styled()` (ResultsDropdown/StyledComponents.tsx).
import React from 'react';
import { Button } from '@bynder/design-system';
import { useNavigableItem } from '../KeyboardNavigation';
import { StyledHeadingInsideButton, StyledHeadingWrapper } from './SharedComponents';

interface Props {
	onSelect: () => void;
	children: React.ReactNode;
	className?: string;
}

export function NavigableHeadingButton({ onSelect, children, className }: Props) {
	const { isActive, itemRef, select } = useNavigableItem<HTMLDivElement>(onSelect);

	return (
		<StyledHeadingWrapper ref={itemRef} $isActive={isActive} className={className}>
			<Button onClick={select} variant="clean" isSmall isFullWidth>
				<StyledHeadingInsideButton>{children}</StyledHeadingInsideButton>
			</Button>
		</StyledHeadingWrapper>
	);
}
